import React from 'react';
import { Modal, Progress } from '@gerdau/hefesto';
import { Container, ModalOutContainer, Subtitle } from './styles';

interface Props {
  text?: string;
  enabled: boolean;
  filename: string;
}

export const truncateFilename = (filename: string, chars: number): string => {
  const lastDotIndex = filename.lastIndexOf('.');
  if (lastDotIndex === -1) {
    return filename;
  }

  const name = filename.slice(0, lastDotIndex);
  const extension = filename.slice(lastDotIndex);

  if (name.length > chars) {
    return name.slice(0, chars).concat('... ').concat(extension);
  } else {
    return filename;
  }
};

const LoadingItems = ({ text, enabled, filename }: Props) => {
  if (!enabled) {
    return null;
  }

  return (
    <ModalOutContainer>
      <Modal
        buttons={{
          right: {
            children: 'Fechar',
            name: 'continue-upload',
            onClick: () => null,
            type: 'button',
            variant: 'primary'
          }
        }}
        modalSize="sm"
        title="Aguarde alguns instantes"
      >
        <Container>
          <Subtitle>
            {text ?? 'Carregando o arquivo'}
            {(filename.length && (
              <strong> {truncateFilename(filename, 18)}</strong>
            )) ||
              null}
          </Subtitle>
          <Progress infinite showPercentNumber={false} />
        </Container>
      </Modal>
    </ModalOutContainer>
  );
};

export default LoadingItems;
